import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentPoliticaCookies } from '../../components/politicaCookies/ContentPoliticaCookies'
import './PoliticaCookies.css'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const PoliticaCookies = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <div className='headerReservarServicio'>
                <HeaderHome />
            </div>
            <div className='cookie-policy-body'>
                <ContentPoliticaCookies />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}